import { jsx as l } from "react/jsx-runtime";
const r = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M11.99 1.968c1.023 0 1.97.521 2.512 1.359l.103.172 7.1 12.25.062.126a3 3 0 0 1-2.568 4.117l-.2.008H5l-.048-.003-.112.002a3 3 0 0 1-2.268-1.226l-.11-.16a3 3 0 0 1-.32-2.545l.073-.194.06-.125L9.366 3.516a3 3 0 0 1 2.625-1.548zM12.01 14l-.127.007a1 1 0 0 0 0 1.986L12 16l.127-.007a1 1 0 0 0 0-1.986zM12 8a1 1 0 0 0-.993.883L11 9v2l.007.117a1 1 0 0 0 1.986 0L13 11V9l-.007-.117A1 1 0 0 0 12 8"
      }
    )
  }
);
export {
  r as default
};
